// eslint-disable-next-line no-restricted-imports
import {notificationController} from '../../../../../code/client/shared/scripts/EntryShared.ts'
import {LobbyImage} from '@colonist/types'
import {type StateCreator} from 'zustand'

export interface GameMuteSlice {
    gameMute: {
        mutedPlayers: string[]
        isMuted: (playerName: string) => boolean
        toggleMuteForPlayer: (playerName: string) => void
        mutePlayer: (playerName: string) => void
        unmutePlayer: (playerName: string) => void
    }
}

export const createGameMuteSlice = (): StateCreator<GameMuteSlice> => (set, get) => ({
    gameMute: {
        mutedPlayers: [],

        isMuted: (playerName: string) => {
            const {mutedPlayers} = get().gameMute
            return mutedPlayers.includes(playerName)
        },

        toggleMuteForPlayer: (playerName: string) => {
            const {isMuted, mutePlayer, unmutePlayer} = get().gameMute
            const muted = isMuted(playerName)

            if(muted) {
                unmutePlayer(playerName)
            } else {
                mutePlayer(playerName)
            }
            const notificationKey = muted ? 'strings:popups.notification.userUnmuted' : 'strings:popups.notification.userMuted'
            notificationController.showNotification(LobbyImage.Chat, {key: notificationKey, options: {username: playerName}}, 2000)
        },

        mutePlayer: (playerName: string) => {
            const {mutedPlayers, isMuted} = get().gameMute
            if(isMuted(playerName)) return

            set((state) => ({
                gameMute: {
                    ...state.gameMute,
                    mutedPlayers: [...mutedPlayers, playerName],
                },
            }))
        },

        unmutePlayer: (playerName: string) => {
            const {mutedPlayers, isMuted} = get().gameMute
            if(!isMuted(playerName)) return

            set((state) => ({
                gameMute: {
                    ...state.gameMute,
                    mutedPlayers: mutedPlayers.filter((name) => name !== playerName),
                },
            }))
        },
    },
})
